import { render, staticRenderFns } from "./PosDetails.vue?vue&type=template&id=eee03c02"
import script from "./PosDetails.vue?vue&type=script&lang=js"
export * from "./PosDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports